import type { ConditionField } from '@/components/ui';

/**
 * Fields available to the auto-rule condition builder for tags. Mirrors the
 * subset of contact properties the backend can match against; expand here
 * once additional indexable fields ship.
 */
export const TAG_RULE_FIELDS: ConditionField[] = [
  { value: 'profile.firstName', label: 'First name' },
  { value: 'profile.lastName', label: 'Last name' },
  { value: 'profile.residence', label: 'Residence' },
  { value: 'profile.nationality', label: 'Nationality' },
  { value: 'contact.primaryEmail', label: 'Primary email' },
  {
    value: 'status.active',
    label: 'Active',
    operators: ['equals', 'not_equals'],
    options: [
      { value: 'true', label: 'Yes' },
      { value: 'false', label: 'No' },
    ],
  },
  {
    value: 'status.doNotContact',
    label: 'Do not contact',
    operators: ['equals', 'not_equals'],
    options: [
      { value: 'true', label: 'Yes' },
      { value: 'false', label: 'No' },
    ],
  },
  { value: 'tags', label: 'Tag', operators: ['contains', 'not_equals'] },
  { value: 'sources', label: 'Source', operators: ['contains', 'not_equals'] },
];

export const TAG_COLOR_PRESETS = [
  '#1F47AB', // brand
  '#0E8E8E', // teal
  '#0F9D6B', // green
  '#D97706', // amber
  '#C0392B', // red
  '#7C3AED', // violet
  '#475569', // slate
];
